import { useMutation, useQueryClient } from "@tanstack/react-query";

import { errorHandler } from "#app/monitoring/errorHandler";
import { showErrorToast, showSuccessToast } from "#app/notifications";
import { deleteManyQuoteRequestLine } from "#modules/quoteRequestLines/infra/deleteManyQuoteRequestLine.api";
import { quoteRequestLinesQuery } from "#modules/quoteRequestLines/quoteRequestLinesQuery";
import { quoteRequestQuery } from "#modules/quoteRequests/infra/quoteRequest.query";

export const useDeleteManyQuoteRequestLine = (options?: {
  onSuccess?: (deletedIds: string[]) => void;
}) => {
  const queryClient = useQueryClient();

  const { mutate, ...rest } = useMutation({
    mutationFn: deleteManyQuoteRequestLine,
    onSuccess: ({ deletedIds, quoteRequestId }) => {
      if (quoteRequestId) {
        void queryClient.invalidateQueries(quoteRequestQuery(quoteRequestId));
        void queryClient.invalidateQueries(quoteRequestLinesQuery());
        showSuccessToast({ title: "Pièce supprimée" });
      }
      options?.onSuccess?.(deletedIds);
    },
    onError: (err) => {
      showErrorToast({
        title: "Une erreur est survenue lors de la suppression de la pièce",
      });
      errorHandler(err);
    },
  });

  return { deleteManyQuoteRequestLine: mutate, ...rest };
};
